export const ENV_IS_PRODUCTION = process.env.NODE_ENV === 'production'
